module.exports = __webpack_public_path__ + "img/data_downlod_bg.8f1f64dc.png";